import { render, staticRenderFns } from "./provider-statistic.vue?vue&type=template&id=58e66627&scoped=true&"
import script from "./provider-statistic.vue?vue&type=script&lang=js&"
export * from "./provider-statistic.vue?vue&type=script&lang=js&"
import style0 from "./provider-statistic.vue?vue&type=style&index=0&id=58e66627&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "58e66627",
  null
  
)

export default component.exports